import { styled } from "@mui/material/styles";

interface VerdictDotProps {
  $color: string;
  $size?: number;
}

/** Color-filled circle used to indicate a verdict status inline. */
export const VerdictDot = styled("span")<VerdictDotProps>(({ $color, $size = 6 }) => ({
  display: "inline-block",
  width: $size,
  height: $size,
  borderRadius: "50%",
  backgroundColor: $color,
  flexShrink: 0,
}));
